import { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { EyeOff, Eye, Lock } from 'lucide-react';
import { Switch } from '@/components/ui/switch';

const API = process.env.REACT_APP_BACKEND_URL;

// Part D: nobody appears in the directory unless they choose to. Contacts are never shown to members.
export default function DirectoryOptInCard({ projectId, directory, onChanged }) {
  const [busy, setBusy] = useState(false);
  if (!directory) return null;
  const listed = !!directory.me?.listed;
  const toggle = async (v) => {
    setBusy(true);
    try {
      await axios.put(`${API}/api/buyer-sourced/${projectId}/directory-opt-in`, { opt_in: v });
      toast.success(v ? 'Your name and flat are now visible to verified members' : 'You are now hidden from the directory');
      onChanged?.();
    } catch { toast.error('Could not change your listing'); } finally { setBusy(false); }
  };
  return (
    <div className="rounded-lg border p-3 space-y-2" data-testid="directory-optin-card">
      {!directory.is_admin_view && (
        <label className="flex items-start justify-between gap-3 cursor-pointer">
          <span className="text-sm">
            <span className="font-medium flex items-center gap-1.5">{listed ? <Eye className="h-4 w-4 text-emerald-600" /> : <EyeOff className="h-4 w-4 text-muted-foreground" />}
              {listed ? 'You are listed in this directory' : 'You are hidden from this directory'}</span>
            <span className="text-xs text-muted-foreground">Only your name, flat and AOP status are shown to verified members of this project. You can change this at any time.</span>
          </span>
          <Switch checked={listed} disabled={busy} onCheckedChange={toggle} data-testid="directory-optin-switch" />
        </label>
      )}
      <p className="text-xs text-muted-foreground flex items-start gap-1.5" data-testid="directory-privacy-note">
        <Lock className="h-3.5 w-3.5 shrink-0 mt-0.5" />
        Email addresses and mobile numbers are kept securely by FBC and never shown to members.
        {directory.hidden_count > 0 && ` ${directory.hidden_count} other ${directory.hidden_count === 1 ? 'owner is' : 'owners are'} on the register but not listed, because they haven't joined FBC or chosen to appear.`}
      </p>
    </div>
  );
}
